import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: ["data"],
  mounted() {
    this.renderChart(this.data.data, this.data.options);
  },
  watch: {
    data: {
      handler: function(val, old) {
        console.log(val);
        this.renderChart(val.data, val.options);
      },
      deep: true
    }
  }
};
